import { formatBodyWeight, formatResultWeight } from '~/utils/weight';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Table } from '~/components/Table/Table';
import { formatPoints } from '~/utils/points';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';
import { LifterResult } from '~/apis/ssf';

interface Props {
  results?: LifterResult[];
  isLoading: boolean;
}

function Row({ result }: { result: LifterResult }) {
  return (
    <Table.Row>
      <Table.Col>
        <Link to={`/competitions/${result.competition.id}/results`}>{result.competition.name}</Link>
      </Table.Col>
      <Table.Col>{result.weight_class.name}</Table.Col>
      <Table.Col>{formatBodyWeight(result.body_weight)}</Table.Col>
      <Table.Col>{result.squat ? formatResultWeight(result.squat) : '-'}</Table.Col>
      <Table.Col>{result.benchpress ? formatResultWeight(result.benchpress) : '-'}</Table.Col>
      <Table.Col>{result.deadlift ? formatResultWeight(result.deadlift) : '-'}</Table.Col>
      <Table.Col>{result.total ? formatResultWeight(result.total) : '-'}</Table.Col>
      <Table.Col>{formatPoints(result.points ?? 0)}</Table.Col>
      <Table.Col>{result.date}</Table.Col>
    </Table.Row>
  );
}

export function CompetitionResultsListTable({ results, isLoading }: Props) {
  return (
    <Fragment>
      <PageLayout.SubHeading>Tävlingar</PageLayout.SubHeading>
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Tävling</Table.Col>
            <Table.Col as="th">Viktklass</Table.Col>
            <Table.Col as="th">Kroppsvikt</Table.Col>
            <Table.Col as="th">Knäböj</Table.Col>
            <Table.Col as="th">Bänkpress</Table.Col>
            <Table.Col as="th">Marklyft</Table.Col>
            <Table.Col as="th">Total</Table.Col>
            <Table.Col as="th" tooltip="Poängsystem: IPFGL">
              Poäng
            </Table.Col>
            <Table.Col as="th">Datum</Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? <Table.Loading cols={8} /> : results?.map(c => <Row result={c} key={c.id} />)}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
